import { Route } from 'react-router-dom'

const RouteWithSubRoutes = (props) => {
  const {
    pageKey,
    path,
    exact,
    component: Component,
    routes,
    ...restProps
  } = props
  return (
    <Route
      path={path}
      exact={exact}
      render={renderProps => (
      // pass the sub-routes down to keep nesting
        <Component
          {...restProps}
          {...renderProps}
          pageKey={pageKey}
          routes={routes}
        />
      )}
    />
  )
}

export default RouteWithSubRoutes
